// Auto-generated file - do not edit manually
export const LOCALE_HASH = 'afa6d674';
